import type { FeatureCode } from '@/utils/disabled-features/disabled-features.interface';
import { Environment } from '@/utils/environment/environment.interface';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { RosaCoreApiService } from '../../libs/rosa';

@Injectable({
    providedIn: 'root'
})
export class DisabledFeaturesService {
    private _coreApiService = inject(RosaCoreApiService);
    private _env = inject(Environment);

    private _disabledFeatures: FeatureCode[] | null = null;

    async initialize() {
        if (this._disabledFeatures) {
            throw new Error('Trying to initialize disabled features multiple times');
        }

        this._disabledFeatures = (await firstValueFrom(
            this._coreApiService.checkedGet(
                `/api/v3/app/{appCode}/environment/{environment}/disabled-features`,
                { path: { appCode: 'advizeo-desktop', environment: this._env.currentMode } },
                true
            )
        )) as FeatureCode[];
    }

    isFeatureDisabled(featureCode: FeatureCode): boolean {
        if (!this._disabledFeatures) {
            throw new Error('Tried to access disabled features before initialization');
        }
        return this._disabledFeatures.includes(featureCode);
    }

    isFeatureEnabled(featureCode: FeatureCode): boolean {
        return !this.isFeatureDisabled(featureCode);
    }
}
